<template>
  <div>
    <h1 class="page-title title"> {{ $t("bank.account.title.bank_accounts") }}</h1>
    <div class="page-ct">
      <div class="section">
        <h4 class="title">{{ $t("bank.account.title.bank_accounts_2") }}</h4>
        <div class="alert alert-danger" v-if="message.errorMessage">
          {{ $t(message.errorMessage) }}
        </div>
        <div class="section-inner">
          <div class="bank-list" data-toggle="buttons">
            <div class="row row-narrow">
              <div class="col-md-3" v-for="item in mapBank" :key="item.key">
                <label :class="item.classActive" class="btn btn-border btn-block rdLabelBank font-custom" :id="item.bankCode"
                       @click="updateBankCode(item)">
                  <input type="radio" name="bank" :value="item.bankCode">
                  {{ item.bankName }}{{ $t("bank.name") }}
                </label>
              </div>
              <div class="col-md-3">
                <a class="btn btn-primary btn-block font-custom" id="searchBankId" @click="openSearch('bank')">
                  {{$t("bank.account.button.search_bank")}}
                </a>
              </div>
            </div>
          </div>
        </div>
        <hr>
        <form class="form-horizontal" novalidate name="bankAccountInfo" @submit.prevent="saveBankAccount()">
          <div class="form-group overflow-auto">
            <label class="control-label col-md-3 float-left">{{ $t("bank.account.label.bank_name") }}</label>
            <div class="col-md-3 float-left">
              <input type="text" class="form-control readonly-blank" v-model="input.bankName" name="bankName" readonly required>
              <div v-if="clickSubmit && !$v.input.bankName.required" class="error-messages ng-active">
                {{ $t("bank.account.input.required") }}
              </div>
            </div>
          </div>
          <div class="form-group overflow-auto">
            <label class="control-label col-md-3 float-left">{{ $t("bank.account.label.bank_branch") }}</label>
            <div class="col-md-3 float-left">
              <input type="text" class="form-control readonly-blank" v-model="input.branchName" name="branchName" readonly required>
              <div v-if="clickSubmit && !$v.input.branchName.required" class="error-messages ng-active">
                {{ $t("bank.account.input.required") }}
              </div>
            </div>
            <div class="col-md-3 float-left">
              <button type="button" class="btn btn-primary"
                      id="searchBranchId" @click="openSearch('branch')" :disabled="disabled">
                {{ $t("bank.account.button.search_branch") }}
              </button>
            </div>

          </div>
          <div class="form-group overflow-auto">
            <label class="control-label col-md-3 float-left">{{ $t("bank.account.label.account_type") }}</label>
            <div class="col-md-9 float-left">
              <label v-for="item in mapAccountType" :key="item.key" class="radio-inline mr-3">
                <input type="radio" v-model="input.bankAccClass" name="accountType" :value="item.key">
                {{ $t(item.value) }}
              </label>
            </div>
          </div>
          <div class="form-group overflow-auto">
            <label class="control-label col-md-3 float-left">{{ $t("bank.account.label.account_number") }}</label>
            <div class="col-md-3 float-left">
              <input type="text" class="form-control" v-model="input.accountNo" name="accountNo" required maxlength="7"/>
              <div v-if="clickSubmit && !$v.input.accountNo.required" class="error-messages ng-active">
                {{ $t("bank.account.input.required") }}
              </div>
              <div v-else-if="clickSubmit && $v.input.accountNo.$error" class="error-messages ng-active">
                {{ $t("profile.error.sepecial_characters") }}
              </div>
            </div>
          </div>
          <div class="form-group overflow-auto">
            <label class="control-label col-md-3 float-left">{{ $t("bank.account.label.account_name") }}</label>
            <div class="col-md-6 float-left">
              <input type="hidden" v-model="input.accountNameKana">
              <p><span style="word-wrap: break-word;">{{ input.accountNameKana }}</span></p>
            </div>
          </div>

          <hr>
          <div class="form-action">
            <button type="submit" class="btn btn-success mr-1">
              {{ $t("bank.account.button.save") }}
            </button>
            <button type="button" class="btn btn-inverse ml-0" @click="backToWithdrawal()">
              {{ $t("bank.account.button.cancel") }}
            </button>
          </div>
          <input type="hidden" v-model="input.customerBankId" :disabled="disabled" class="form-control"/>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {createNamespacedHelpers} from "vuex";
import ModalPlugin from "@/common/plugins/ModalPlugin.js";
import IConstants from "@/common/constants/IConstants.js";
import {maxLength, numeric, required} from 'vuelidate/lib/validators'
import $ from "jquery";
import offModalEvent from "@/common/mixins/offModalEvent";
import {GET_HEADER_INFO} from "@/store/modules/header/type";

const { mapMutations: mapNewsMutations} = createNamespacedHelpers("news");
const { mapActions: mapHeaderActions} = createNamespacedHelpers("header");

export default {
  data() {
    return {
      SERVICE_NAME: "bankAccount",
      model: null,
      clickSubmit: false,
      disabled: true,
      bank: null,
      input: {
        bankCode: '',
        bankName: '',
        branchName: '',
        branchId: '',
        customerBankId: '',
        bankAccClass: '',
        accountNo: '',
        accountName: '',
        accountNameKana: ''
      },
      mapBank: null,
      mapAccountType: IConstants.getMapAccountType(),
      message: {
        errorMessage: null,
        successMessage: null
      },
    }
  },
  mixins: [offModalEvent],
  created() {
    this[GET_HEADER_INFO]();
    this.initScreen();
  },
  mounted() {
    this.getBankSelected();
    this.getBranchSelected();
  },
  destroyed() {
    this.offEventName(this.IConstants.EVENT_NAME.AFTER_SELECT_BANK);
    this.offEventName(this.IConstants.EVENT_NAME.AFTER_SELECT_BRANCH);
  },
  methods: {
      ...mapNewsMutations([
          'updateFields'
      ]),
      ...mapHeaderActions([
          GET_HEADER_INFO
      ]),
    async initScreen() {
      await this.getBankInfo();
    },
    async getBankInfo() {
      //check masking/unmasking
      await this.$service.getService(this.SERVICE_NAME).getBankInfo().then((result) => {
        if (!result.authenticateModel.maskingVerifiedPerRequest) return this.backToWithdrawal()

        this.mapBank = result.mapDirectDepositBank;
        this.bank = result.listCustomerBankInfo[0];
        this.updateBankAccount(this.bank);
        if (this.bank.bankCode) {
          $("#searchBranchId").removeAttr("disabled");
          for (let i = 0; i < this.mapBank.length; i++) {
            if (this.bank.bankCode === this.mapBank[i].bankCode) {
              this.mapBank[i]["classActive"] = "active";
            }
          }
        }
      });
    },
    updateBankAccount(bankInfo) {
      this.input.bankCode = bankInfo.bankCode;
      if (bankInfo.bankName) {
        this.input.bankName = bankInfo.bankName;
      }
      this.input.branchName = bankInfo.branchName;
      this.input.branchId = bankInfo.branchCode;
      this.input.customerBankId = bankInfo.customerBankId;
      this.input.bankAccClass = bankInfo.bankAccClass !== '' ? bankInfo.bankAccClass : '1';
      this.input.accountNo = bankInfo.accountNo;
      this.input.accountName = bankInfo.accountName;
      this.input.accountNameKana = bankInfo.accountNameKana;
    },
    updateBankCode(item) {
      !this.input && (this.input = []);
      if (item.bankCode != null || item.bankCode !== undefined) {
        this.input.bankCode = item.bankCode;
        this.input.bankName = item.bankName;
      } else {
        this.input.bankCode = null;
        this.input.bankName = null;
      }
      this.input.branchName = null;
      this.input.branchId = null;
      $("#searchBranchId").removeAttr("disabled");
    },
    openSearch(mode) {
      if (mode === 'bank') {
        this.$service.getService(this.SERVICE_NAME).searchBankPopup().then((response) => {
          $("#searchBankId").removeClass("active");
          this.model = response;
          this.$modal.openSearchBank(this.model);
        });
      } else if (mode === 'branch') {
        const bankCode = this.input.bankCode;
        const params = "bankCode=" + bankCode;
        this.$service.getService(this.SERVICE_NAME).searchBranchPopup(params).then((response) => {
          this.model = response;
          this.model.bankCode = bankCode;
          this.$modal.openSearchBranch(this.model);
        });
      }
    },
    getBankSelected: function () {
      ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.AFTER_SELECT_BANK, (bankInfo) => {
        this.updateBankCode(bankInfo);
        $(".rdLabelBank").removeClass("active");
        for (let i = 0; i < this.mapBank.length; i++) {
          if (bankInfo.bankCode === this.mapBank[i].bankCode) {
            $("#" + bankInfo.bankCode).addClass("active");
          }
        }
      });
    },
    getBranchSelected: function () {
      ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.AFTER_SELECT_BRANCH, (branchInfo) => {
        this.input.branchName = branchInfo.branchName;
        this.input.branchId = branchInfo.branchCode;
      });
    },
    saveBankAccount() {
      $("html, body").animate({scrollTop: 0}, "slow");
      this.clickSubmit = true;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.disabled = true;
        let bankName = this.input.bankName;
        let branchName = this.input.branchName;
        let bankNameFullSize = encodeURIComponent(bankName);
        let branchNameFullSize = encodeURIComponent(branchName);
        let formData = new FormData();

        formData.append("condition.accountName", this.input.accountName);
        formData.append("condition.accountNameKana", this.input.accountNameKana);
        formData.append("condition.accountNo", this.input.accountNo);
        formData.append("condition.bankAccClass", this.input.bankAccClass);
        formData.append("condition.bankCode", this.input.bankCode);
        formData.append("condition.branchId", this.input.branchId);
        formData.append("condition.customerBankId", this.input.customerBankId);
        formData.append("condition.bankName", bankNameFullSize);
        formData.append("condition.branchName", branchNameFullSize);

        //check masking/unmasking
        this.$service.getService(this.SERVICE_NAME).addBankTransfer(formData).then((response) => {
            if (response instanceof Error) {
              this.message.errorMessage = "error.happen";
            } else {
                if(response.errorVerifyMsg) {
                  return this.backToWithdrawal();
                }

                if (response.errorMessage == null) {
                    this.$router.push({
                        name: 'withdrawal',
                        params: {"changePaymentInfor": "bank.account.message.success"}
                    });
                } else {
                    this.message.errorMessage = response.errorMessage;
                    this.message.successMessage = null;
                }
            }
        }).catch(() => {
            this.message.errorMessage = "error.happen";
        });
      }
    },
    backToWithdrawal: function () {
      this.$router.push({name: 'withdrawal'});
    }
  },
  validations: {
    input: {
      bankName: {
        required
      },
      branchName: {
        required
      },
      accountNo: {
        required,
        maxLength: maxLength(7),
        numeric
      }
    },
  }
}
</script>

<style scoped>
  .section-inner{
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .font-custom{
    font-size: 14px;
    white-space: nowrap;
  }
</style>
